import React from 'react';
import { CheckCircle2, RotateCcw } from 'lucide-react';
import { typeClass, inr, formatDate, isArchived } from './helpers';

const TYPES = ['Valuation Report', 'Stage Bill', 'Stability Certificate'];
const typeColor = (t) => (t === 'Stage Bill' ? '#d97706' : t === 'Stability Certificate' ? '#16a34a' : '#2563eb');
const typeBg = (t) => (t === 'Stage Bill' ? '#fef3c7' : t === 'Stability Certificate' ? '#dcfce7' : '#dbeafe');

export default function ClosedTab({ reports, staffById, onReopen }) {
  const closed = reports.filter(isArchived).sort((a, b) => new Date(b.archived_at || b.created_at) - new Date(a.archived_at || a.created_at));
  if (closed.length === 0) {
    return (
      <div className="empty" data-testid="closed-tab">
        <div className="empty-icon"><CheckCircle2 style={{ width: 44, height: 44, strokeWidth: 1.5 }} /></div>
        <h3>No closed works yet</h3>
        <p>Works appear here once fully paid, collected, and moved to Closed. Tap Reopen to bring one back to Active.</p>
      </div>
    );
  }
  const grouped = {};
  closed.forEach((r) => { const t = r.work_type || 'Valuation Report'; (grouped[t] = grouped[t] || []).push(r); });

  return (
    <div data-testid="closed-tab">
      {TYPES.filter((t) => grouped[t]).map((t) => {
        const list = grouped[t];
        const total = list.reduce((s, r) => s + Number(r.fees || 0) - Number(r.discount || 0), 0);
        return (
          <div key={t}>
            <div style={{ marginTop: 14, marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', background: typeBg(t), borderLeft: `4px solid ${typeColor(t)}`, borderRadius: 4 }}>
              <div><div style={{ fontSize: 14, fontWeight: 700, color: typeColor(t) }}>{t}</div><div style={{ fontSize: 11, color: '#57534e' }}>{list.length} closed</div></div>
              <div style={{ textAlign: 'right' }}><div style={{ fontSize: 10, color: '#57534e', textTransform: 'uppercase', letterSpacing: 1 }}>Total</div><div className="mono" style={{ fontSize: 14, fontWeight: 700, color: typeColor(t) }}>{inr(total)}</div></div>
            </div>
            {list.map((r) => {
              const st = r.staff_id ? staffById[r.staff_id] : null;
              return (
                <div key={r.id} className={`report-card ${typeClass(r.work_type)}`} style={{ opacity: 0.92, marginBottom: 10 }} data-testid={`closed-card-${r.id}`}>
                  <div className="report-top">
                    <div className="report-info">
                      <div className="report-name">{r.client_name || 'Name not added'}</div>
                      {r.file_ref && <div className="mono" style={{ fontSize: 11, fontWeight: 700, color: '#7c2d12', background: '#fef3c7', border: '1px solid #fde68a', padding: '2px 8px', borderRadius: 4, display: 'inline-block', marginTop: 4 }}>{r.file_ref}</div>}
                      <div className="meta-line" style={{ color: '#047857', fontWeight: 600, marginTop: 6 }}>{'\u2713'} Fee: {inr(Number(r.fees || 0) - Number(r.discount || 0))}</div>
                      <div className="meta-line" style={{ fontSize: 10 }}>Staff: <strong>{st ? st.name : '\u2014'}</strong> &middot; Closed {formatDate(r.archived_at || r.created_at)}</div>
                    </div>
                    <div className="report-right">
                      <button className="btn-outline" onClick={() => onReopen(r)} data-testid={`reopen-${r.id}`}><RotateCcw className="icon" /> Reopen</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
